import Helper from '../../../utils/helper';

export const buildRefundCustomerChoice = (
    isCustomerRefundMethodChoiceRequired: boolean,
    isPaymentBankAccount: boolean,
    selectedBankAccount: any,
    isPaymentCashOnStore: boolean,
    isPaymentLcwMoney: boolean
) => {
    if (!isCustomerRefundMethodChoiceRequired) {
        return null;
    }

    if (isPaymentBankAccount && selectedBankAccount) {
        return {
            BankAccountId: selectedBankAccount.bankAccountId,
            RefundCustomerChoiceId: 0,
            RefundReasonId: 0,
            ReferenceId: 0,
            RefundPaymentMethodId: 1,
        };
    }

    if (isPaymentCashOnStore) {
        return { RefundPaymentMethodId: 20 };
    }

    if (isPaymentLcwMoney) {
        return { RefundPaymentMethodId: 3 };
    }

    return null;
};

export const buildCreateReturnParams = (options: {
    createReturnRequest: any;
    isSellerStore: boolean;
    checkedCMIY: boolean;
    simulateReturn: any;
    selectedSellerID?: number;
    isCmMpRejectReturn: boolean;
    isCustomerRefundMethodChoiceRequired: boolean;
    isPaymentBankAccount: boolean;
    selectedBankAccount: any;
    isPaymentCashOnStore: boolean;
    isPaymentLcwMoney: boolean;
}) => {
    const {
        createReturnRequest,
        isSellerStore,
        checkedCMIY,
        simulateReturn,
        selectedSellerID,
        isCmMpRejectReturn,
        isCustomerRefundMethodChoiceRequired,
        isPaymentBankAccount,
        selectedBankAccount,
        isPaymentCashOnStore,
        isPaymentLcwMoney,
    } = options;

    const params: any = {
        return: {
            createReturnItems: createReturnRequest.items,
            customerId: createReturnRequest.customerId,
            saleOrderId: createReturnRequest.orderId,
            returnId: 0,
            rmaCode: 0,
            departmentName: null,
            hasLostPackage: false,
            storeCode: Helper.getStoreCode(),
        },
        isMarketPlaceReturn: isSellerStore,
        refundCustomerChoice: null,
        isCMIYChecked: checkedCMIY,
        isLostPackage: simulateReturn.isLostPackage,
    };

    if (selectedSellerID && isCmMpRejectReturn) {
        params.senderSellerId = selectedSellerID;
    }

    params.refundCustomerChoice = buildRefundCustomerChoice(
        isCustomerRefundMethodChoiceRequired,
        isPaymentBankAccount,
        selectedBankAccount,
        isPaymentCashOnStore,
        isPaymentLcwMoney
    );

    return params;
};

export const buildInsertBankAccountParams = (insertBankAccountRequest: any, customerID: number) => {
    const params: any = {
        bankAccount: {},
        customerId: customerID,
    };

    if (insertBankAccountRequest.bankSelection) {
        params.bankAccount.bankId = insertBankAccountRequest.bankSelection;
    }
    if (insertBankAccountRequest.nameSurname?.length > 0) {
        params.bankAccount.accountOwner = insertBankAccountRequest.nameSurname;
    }
    if (insertBankAccountRequest.accountHolder?.length > 0) {
        params.bankAccount.accountOwner = insertBankAccountRequest.accountHolder;
    }
    if (insertBankAccountRequest.accountNumber?.length > 0) {
        params.bankAccount.accountNumber = insertBankAccountRequest.accountNumber;
    }
    if (insertBankAccountRequest.swiftCode?.length > 0) {
        params.bankAccount.bankCode = insertBankAccountRequest.swiftCode;
    }
    if (insertBankAccountRequest.iban?.length > 0) {
        params.bankAccount.ibanNumber = insertBankAccountRequest.iban.replace(/\s/g, '');
    }
    if (insertBankAccountRequest.nationalId?.length > 0) {
        params.bankAccount.nationalId = insertBankAccountRequest.nationalId;
    }
    if (insertBankAccountRequest.personalNumber?.length > 0) {
        params.bankAccount.personalNumber = insertBankAccountRequest.personalNumber;
    }
    if (insertBankAccountRequest.fatherName?.length > 0) {
        params.bankAccount.accountFatherName = insertBankAccountRequest.fatherName;
    }

    return params;
};
